import type { SingleAvailableOpportunity } from '@ps/isp-web-services-types';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useEffect, useState } from 'react';
import { Field, useField } from 'react-final-form';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { Odds } from '@swf/sports/components';

import useHaveOddsChangedWithinDuration from '../../../../../../../../hooks/useHaveOddsChangedWithinDuration';
import useOpportunityOddsChanges from '../../../../../../../../hooks/useOpportunityOddsChanges';

import { TXTWCL_SP } from './StartingPriceToggle.messages.json';
import styles from './StartingPriceToggle.scss';

interface Props {
  opportunity: SingleAvailableOpportunity;
}

const StartingPriceToggle: React.FC<Props> = ({ opportunity }) => {
  const odds = opportunity.winRunnerOdds;
  const [previouslyHadOdds, setPreviouslyHadOdds] = useState<boolean>(odds !== undefined);

  const { input } = useField(`${opportunity.id}.startingPriceSelected`, {
    type: 'checkbox',
    initialValue: !previouslyHadOdds
  });

  useEffect(() => {
    if (odds) setPreviouslyHadOdds(true);
  }, [odds]);

  const hasAutoAcceptEnabled = useSelector(select.account.hasAutoAcceptEnabled);
  const { haveOddsChangedWithinDuration } = useHaveOddsChangedWithinDuration(opportunity);
  const { haveOddsChanged } = useOpportunityOddsChanges(opportunity);

  return (
    <>
      <Field
        {...input}
        name={input.name}
        id={input.name}
        component="input"
        disabled={!odds && input.checked}
        className={styles.srOnly}
      />
      <label
        htmlFor={input.name}
        className={classNames(styles.container, { [styles.toggle]: previouslyHadOdds })}
      >
        <span
          className={classNames(styles.option, styles.startingPrice, {
            [styles.activeOption]: input.checked
          })}
        >
          <Translation {...TXTWCL_SP} />
        </span>
        <span
          className={classNames(styles.option, styles.odds, {
            [styles.activeOption]: !input.checked,
            [styles.oddsChanged]:
              (hasAutoAcceptEnabled && haveOddsChangedWithinDuration) ||
              (haveOddsChanged && !hasAutoAcceptEnabled)
          })}
        >
          {odds ? <Odds {...odds} /> : '-/-'}
        </span>
      </label>
    </>
  );
};

export default StartingPriceToggle;
